import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateServiceMasterPage = withSuspense(lazy(() => import('./create-services-master-page')));
export default CreateServiceMasterPage;
